import { useState, useEffect, Fragment } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import FleetWebApi from "../Api/FleetWebApi";
import { Typography } from "@mui/material";
import { NavLink } from "react-router-dom";

function LocationInfo(props) {

  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [locationDetails, setLocationDetails] = useState(null);
  useEffect(() => {
    setIsLoaded(false);
    if (props.locationId.length > 0) {
      FleetWebApi.getLocationData(props.locationId).then(
        (result) => {
          setLocationDetails(result.response);
          setIsLoaded(true);
        },
        (error) => {
          console.log(error);
          setError(error.message);
        }
      );
    }
  }, [props.locationId]);


  if (error) {
    return <div>{error}</div>;
  } else if (!isLoaded) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else if (locationDetails !== null) {
    return (
      <div>
        {locationDetails.map((location, index) => (
          <Grid key={location.locationID || index} container spacing={3} marginBottom={2}>
            <Grid item xs={12} md={8} lg={4}>
              <Paper>
                <Table classes={{ root: "reactivetable" }}>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Location ID
                      </TableCell>
                      <TableCell data-th="id">
                        <Fragment>
                          <NavLink
                            to={"/location/dashboard/" + location.locationID}
                            className="Nav_link"
                          >
                            {location.locationID}
                          </NavLink>
                        </Fragment>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Name
                      </TableCell>
                      <TableCell data-th="Name">
                        {location.location}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Street
                      </TableCell>
                      <TableCell data-th="Street">
                        {location.street}
                      </TableCell>
                    </TableRow>


                  </TableBody>
                </Table>
              </Paper>
            </Grid>

            <Grid item xs={12} md={8} lg={4}>
              {
                location.sharees.length >= 1 ? (
                  <Paper>
                    <Table classes={{ root: "reactivetable" }}>
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">Sharees</TableCell>
                        </TableRow>

                        {location.sharees.map((sharee, x) => (
                          <TableRow key={x.sharee}>
                            <TableCell align="center" data-th="sharee">
                              {sharee}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>

                  </Paper>
                )
                  : (
                    <Typography align="center">No Sharees</Typography>
                  )}
            </Grid>

            <Grid item xs={12} md={8} lg={4}>
              {location.flowieOs.length === 0 &&
                location.hubbies.length === 0 &&
                location.pucks.length === 0 &&
                location.sentrees.length === 0 &&
                location.shutties.length === 0 &&
                location.shuttie2s.length === 0 &&
                location.waterMeters.length === 0 ? (
                <Typography align="center">No Devices on this property</Typography>
              ) : (
                <Paper>
                  <Table classes={{ root: "reactivetable" }}>
                    <TableBody>
                      <TableRow>
                        <TableCell align="center">Type</TableCell>
                        <TableCell align="center">Registered</TableCell>
                        {/* <TableCell align="center">Online</TableCell> */}
                      </TableRow>

                      {location.waterMeters.length ? (
                        <TableRow>
                          <TableCell component="th" align="center" scope="row">
                            Flowies
                          </TableCell>
                          <TableCell data-th="WaterMeter" align="center">
                            {location.waterMeters.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlineWaterMeter}</TableCell> */}
                        </TableRow>
                      ) : null}
                      {location.sentrees.length ? (
                        <TableRow>
                          <TableCell component="th" align="center" scope="row">
                            Sentrees
                          </TableCell>
                          <TableCell data-th="Sentrees" align="center">
                            {location.sentrees.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlineSentree}</TableCell> */}
                        </TableRow>
                      ) : null}
                      {location.hubbies.length ? (
                        <TableRow>
                          <TableCell component="th" align="center" scope="row">
                            Hubbies
                          </TableCell>
                          <TableCell data-th="Hubbies" align="center">
                            {location.hubbies.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlineHubbie}</TableCell> */}
                        </TableRow>
                      ) : null}
                      {location.shutties.length ? (
                        <TableRow>
                          <TableCell align="center" component="th" scope="row">
                            Shutties
                          </TableCell>
                          <TableCell align="center" data-th="Shutties">
                            {location.shutties.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlineShuttie}</TableCell> */}
                        </TableRow>
                      ) : null}
                      {location.shuttie2s.length ? (
                        <TableRow>
                          <TableCell align="center" component="th" scope="row">
                            Shuttie2s
                          </TableCell>
                          <TableCell align="center" data-th="Shuttie2s">
                            {location.shuttie2s.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlineShuttie2}</TableCell> */}
                        </TableRow>
                      ) : null}
                      {location.flowieOs.length ? (
                        <TableRow>
                          <TableCell align="center" component="th" scope="row">
                            FlowieO
                          </TableCell>
                          <TableCell align="center" data-th="FlowieO">
                            {location.flowieOs.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlineFlowieO}</TableCell> */}
                        </TableRow>
                      ) : null}
                      {location.pucks.length ? (
                        <TableRow>
                          <TableCell align="center" component="th" scope="row">
                            Pucks
                          </TableCell>
                          <TableCell align="center" data-th="Pucks">
                            {location.pucks.length}
                          </TableCell>
                          {/* <TableCell align="center">{OnlinePuck}</TableCell> */}
                        </TableRow>
                      ) : null}
                    </TableBody>
                  </Table>
                </Paper>
              )}
            </Grid>
          </Grid>
        ))}

      </div>
    );
  } else {
    return (
      <Paper>
        <div>Trouble Fetching Location Details</div>
      </Paper>
    )
  }
}
export default LocationInfo;
